import { registerContext } from '@client/new/components/AsyncRenderer/AsyncRenderer';
import { useExtrasVM } from './viewModel/extras.viewModel';
import { ExtrasView } from './Extras.view';

export const extrasVM = registerContext('extrasVM', useExtrasVM);

export const ExtrasPage = () => (
  <extrasVM.ValueProvider params="0" renderer={() => <ExtrasView />} />
);
